/* ELAYVA homepage — scroll reveal, marquee pause, smooth anchors
   Scoped to .elayva-home elements on the index template */
(() => {
  const roots = document.querySelectorAll(".elayva-home");
  if (!roots.length) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Scroll reveal */
  const revealNodes = document.querySelectorAll(".elayva-home [data-home-reveal]");
  if (reduceMotion) {
    revealNodes.forEach((n) => n.classList.add("is-revealed"));
  } else if ("IntersectionObserver" in window) {
    const obs = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add("is-revealed");
          observer.unobserve(e.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );
    revealNodes.forEach((n) => obs.observe(n));
  } else {
    revealNodes.forEach((n) => n.classList.add("is-revealed"));
  }

  /* Instagram marquee — pause off-screen */
  const track = document.querySelector(".elayva-home [data-instagram-track]");
  const rail  = document.querySelector(".elayva-home [data-instagram-rail]");
  if (track && rail && "IntersectionObserver" in window) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          rail.style.animationPlayState = (reduceMotion || !e.isIntersecting) ? "paused" : "running";
        });
      },
      { rootMargin: "100px" }
    ).observe(track);
  }

  /* Smooth in-page anchors */
  document.querySelectorAll('.elayva-home a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (ev) => {
      const href = link.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.querySelector(href);
      if (!target) return;
      ev.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  });
})();
